import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { useParams } from "react-router-dom";
import { CardTitle } from "reactstrap";
import logoImg from "@images/logo-lg (3).png";
import { QRCode } from "react-qrcode-logo";

const Login = () => {
  const { id } = useParams();
  const url = window.location.href;

  console.log("url", url);

  return (
    <React.Fragment>
      <div className="auth-wrapper auth-v1">
        <div>
          <Card className="w-100 m-0">
            <Row className="m-0 w-100">
              {/* <Col className="p-0" lg="6"> */}
              {/* <div className="photo-img" /> */}
              {/* </Col> */}
              <Col className="p-0" lg="12">
                <CardBody className="p-4">
                  <CardTitle tag="h4" className="mb-1 text-center">
                    <img
                      src={logoImg}
                      alt="loginImg"
                      // style={{ height: "65px" }}
                      height="40%"
                      width="100%"
                    />
                  </CardTitle>
                  <div style={{ textAlign: "center", marginTop: 40 }}>
                    <QRCode
                      value={
                        url.includes("qr-winter")
                          ? `http://qr-msil.rezo.ai/qr-winter/tableData/${id}`
                          : `http://qr-msil.rezo.ai/qr/tableData/${id}`
                      }
                      size={200}
                      // logoImage={logoSuzuki}
                    />
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      marginTop: 50,
                      justifyContent: "center",
                    }}
                  >
                    <span>
                      <strong>
                        {" "}
                        Show this QR code to Service Advisor at mentioned Dealer
                        Workshop. This offer is applicable on Periodic
                        Maintenance Service.
                      </strong>
                    </span>
                  </div>
                </CardBody>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Login;
